import template from "./cash_deliveries.html";
import controller from "./cash_deliveries.controller";
import "./cash_deliveries.scss";

let branchManagementCashDeliveriesComponent = {
  restrict: "E",
  bindings: {},
  template,
  controller
};

export default branchManagementCashDeliveriesComponent;


// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/cash_deliveries/cash_deliveries.component.js